
Monet.UI = Monet.UI || {};

Monet.UI.ContentMenuItem = function(data) {

    if (data) {
        this.elItem = document.createElement('div');
        this.elItemIcon = document.createElement('div');
        this.elItemText = document.createElement('div');
        this.elItem.className = `MonetUIListItem ${data.customClassname || ''}`;
        this.elItemIcon.className = 'MonetUIMenuRouteIcon ' + data.icon;
        this.elItemText.className = 'MonetUIMenuRouteText';

        this.elItemText.innerHTML = data.description;
        this.elItemText.setAttribute('value', data.id);

        if (data.action) {
            this.elItem.addEventListener('click', data.action);
        }

        this.elItem.appendChild(this.elItemText);
        this.elItem.appendChild(this.elItemIcon);

        return this.elItem;

    } else {
        console.log('No enough data to render list item');
    }

    return false;

};